module.exports = __webpack_public_path__ + "img/imageonline-co-roundcorner.53ff0a11.png";